import * as React from 'react'
import { Theme, useTheme } from '@mui/material/styles'
import { FC, useMemo } from 'react'

import { PiggyBank } from '@sales-center/components'

import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'

interface Props {
  percentageComplete: number
  type: 'detail' | 'summary'
}

interface StyleProps {
  barHeight: number
  isSummary: boolean
  percentageComplete: number
}

const getStyles = (props: StyleProps, theme: Theme) => ({
  barGraph: {
    position: 'relative',
    height: `${props.barHeight}px`,
    width: '100%',
    margin: `${theme.spacing(0.5)} ${theme.spacing(0)}`,
  },

  barTotal: {
    position: 'absolute',
    backgroundColor: 'rgba(0, 90, 163, 0.1)',
    height: '100%',
    borderRadius: `${props.barHeight / 2}px`,
    right: 0,
    width: props.isSummary
      ? `calc(${100 - props.percentageComplete}% - 20px)`
      : '100%',
  },

  barComplete: {
    position: 'absolute',
    backgroundColor: '#005AA3',
    height: '100%',
    borderRadius: `${props.barHeight / 2}px`,
    width: props.isSummary
      ? `calc(${props.percentageComplete}% - 20px)`
      : `${props.percentageComplete}%`,
  },

  icon: {
    position: 'absolute',
    width: '28px',
    height: 'auto',
    top: '-6px',
    left: `calc(${props.percentageComplete}% - 15px)`,
  },
})

export const ProjectedSalesVisualization: FC<Props> = (props) => {
  const { percentageComplete, type } = props

  const isSummary = useMemo(() => type == 'summary', [type])
  const barHeight = useMemo(() => (isSummary ? 18 : 12), [isSummary])
  const styles = getStyles(
    { barHeight, isSummary, percentageComplete },
    useTheme(),
  )
  return (
    <Tooltip title={`${percentageComplete}% Complete`}>
      <Box sx={styles.barGraph}>
        {type == 'summary' && <PiggyBank sx={styles.icon} />}
        <Box sx={styles.barComplete} />
        <Box sx={styles.barTotal}></Box>
      </Box>
    </Tooltip>
  )
}

ProjectedSalesVisualization.displayName = 'ProjectedSalesVisualization'
